// After a new release the old page files are gone, so a tab that was open before it can fail to load a page.
// Reloading once fetches the new files. The guard stops a reload loop if the problem is something else.
const KEY = 'fuzzscan_chunk_reload_at';

export const isChunkError = (error) => /dynamically imported module|importing a module script failed|Loading chunk|ChunkLoadError/i.test(String(error?.message || error || ''));

export function reloadOnce() {
  try {
    const last = Number(sessionStorage.getItem(KEY) || 0);
    if (Date.now() - last < 30000) return false;
    sessionStorage.setItem(KEY, String(Date.now()));
  } catch { /* storage blocked: still try one reload */ }
  window.location.reload();
  return true;
}
